<template>
  <div class="modal-dim on yd-order-state-modal">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom order-state-inner">
        <div class="modal order-state-sheet">
          <div class="modal-head order-state-head">
            <h1 class="order-state-title">{{ title }}</h1>
          </div>

          <div class="modal-delete order-state-close" @click="close">
            <i class="i-modal-delete"></i>
          </div>
          <div class="modal-con check order-state-content">
            <div class="modal-txt order-state-copy">
              <ul class="check-ul order-state-list">
                <li
                  class="form-li order-state-item"
                  :class="{
                    'is-current': item.value === form.prevState,
                    'is-past': index < prevIndex,
                    'is-available': index > prevIndex,
                    'is-selected': index > prevIndex && item.value === form.orderState
                  }"
                  v-for="(item, index) in orderState"
                  :key="item.value"
                >
                  <div class="radio-box order-state-option">
                    <label class="radio order-state-label">
                      <input
                        type="radio"
                        name="radio"
                        :value="item.value"
                        :disabled="index <= prevIndex"
                        v-model="form.orderState"
                      />
                      <span class="radio-txt order-state-label-text" :class="{ disabled: index <= prevIndex }">
                        {{ item.label }}</span
                      >
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="modal-btn order-state-footer">
            <div class="btn-wrap order-state-actions">
              <button class="btn order-state-button order-state-cancel yd-cta yd-cta--secondary" @click="cancel">
                {{ rejectText }}
              </button>
              <button class="btn order-state-button order-state-confirm yd-cta yd-cta--primary" @click="confirm">
                {{ confirmText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { defineEmits, defineProps, computed, toRefs, ref } from 'vue';
import { show, modalList, close } from '@/common/utils/ControlModal';
import { useI18n } from 'vue-i18n';
import { cloneDeep } from 'lodash';
import Util from '@/common/utils/Util';
import { ORDER_STATUS } from '@/common/constants/ConstCode';

const { translator } = Util;
const store = useStore();
const { t } = useI18n();

const { data } = defineProps(['data']);
const emits = defineEmits(['close']);

const { title = '', text = '', confirmText = '', rejectText = '' } = toRefs(data);
const form = ref(data.form);

const prevIndex = computed(() => {
  return orderState.value.findIndex((v) => {
    if (v.value === form?.value?.prevState) return v;
  });
});

const orderState = computed(() => {
  let constants = Object.values(store.getters['constant/getConstant'][['ORDER_STATE']]);
  constants = constants.splice(1, constants.length);

  // 배달인 경우 픽업완료, 포장완료는 제외
  console.log('form.value.orderType', form.value.order.orderType);
  if (form.value.order.orderType === 'TYPE_DELIVERY') {
    return constants
      .filter((elem) => elem.key !== ORDER_STATUS.PACKAGING_COMPLETED && elem.key !== ORDER_STATUS.PICKUP_COMPLETED)
      .map((elem) => {
        return {
          label: translator(elem),
          value: elem.key
        };
      });
  } else {
    // 포장인 경우 배달중, 배달도착, 배달완료는 제외
    return constants
      .filter(
        (elem) =>
          elem.key !== ORDER_STATUS.DELIVERY &&
          elem.key !== ORDER_STATUS.DELIVERY_ARRIVED &&
          elem.key !== ORDER_STATUS.DELIVERY_COMPLETED
      )
      .map((elem) => {
        return {
          label: translator(elem),
          value: elem.key
        };
      });
  }
});

const cancel = () => emits('close');
const confirm = () => {
  const { orderState } = form.value;
  if (!orderState) return;

  switch (orderState) {
    case ORDER_STATUS.COOKING:
    case ORDER_STATUS.DELIVERY:
      selectTimeSpan();
      break;
    case ORDER_STATUS.ORDER_CANCELLED:
      selectCancelReason();
      break;
    default:
      send();
      break;
  }

  close('ChangeOrderState');
};

const send = () => {
  let cloneData = cloneDeep(form.value);

  const payload = {
    orderNo: cloneData.order.orderNo,
    orderState: cloneData.orderState,
    orderType: cloneData.order.orderType,
    orderManageNo: cloneData.order.orderManageNo,
    storeUserNo: cloneData.storeUserNo,
    userNo: cloneData.order.userNo,
    nameKr: cloneData.store.nameKr,
    nameVn: cloneData.store.nameVn,
    nameEn: cloneData.store.nameEn
  };

  store.dispatch('admin_order/CHANGE_ORDER_STATE', payload);
};

const selectTimeSpan = () => {
  const alertData = {
    title: t('modal.check_time_span.title'),
    rejectText: t('modal.check_time_span.cancel'),
    confirmText: t('modal.check_time_span.confirm'),
    form: form.value
  };

  show(modalList.CheckTimeSpan, alertData);
};
const selectCancelReason = () => {
  const alertData = {
    title: t('modal.cancel_reason.title'),
    rejectText: t('modal.cancel_reason.cancel'),
    confirmText: t('modal.cancel_reason.confirm'),
    form: form.value
  };
  show(modalList.CancelReason, alertData);
};
</script>

<style scoped>
.yd-order-state-modal .order-state-inner {
  box-sizing: border-box;
  padding: 12px;
  padding: 12px 12px max(12px, env(safe-area-inset-bottom));
}

.yd-order-state-modal .order-state-inner.bottom .order-state-sheet {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  max-width: 420px;
  max-height: calc(100vh - 24px);
  max-height: calc(100dvh - 24px);
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #edf1f4;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(31, 45, 61, 0.14);
}

.yd-order-state-modal .order-state-head {
  flex: 0 0 auto;
  box-sizing: border-box;
  padding: 20px 52px 10px 20px;
  text-align: left;
}

.yd-order-state-modal .order-state-title {
  color: #243746;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.yd-order-state-modal .order-state-close {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  cursor: pointer;
}

.yd-order-state-modal .order-state-close:active {
  background: #f1f5f8;
}

.yd-order-state-modal .order-state-close > i {
  position: static;
}

.yd-order-state-modal .order-state-content {
  flex: 1 1 auto;
  box-sizing: border-box;
  display: flex;
  min-height: 0;
  padding: 8px 16px 6px;
  overflow: hidden;
}

.yd-order-state-modal .order-state-copy {
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  color: #425466;
  text-align: left;
}

.yd-order-state-modal .order-state-list {
  flex: 1 1 auto;
  box-sizing: border-box;
  width: 100%;
  min-height: 0;
  max-height: 52vh;
  max-height: 52dvh;
  padding: 2px 4px 2px 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  -webkit-overflow-scrolling: touch;
}

.yd-order-state-modal .order-state-item {
  box-sizing: border-box;
  width: 100%;
  margin: 0 0 8px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #dce5eb;
  border-radius: 10px;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    box-shadow 0.15s ease;
}

.yd-order-state-modal .order-state-item:last-child {
  margin-bottom: 0;
}

.yd-order-state-modal .order-state-option,
.yd-order-state-modal .order-state-label {
  width: 100%;
}

.yd-order-state-modal .order-state-label {
  box-sizing: border-box;
  display: flex;
  min-width: 0;
  min-height: 48px;
  align-items: center;
  padding: 11px 14px;
}

.yd-order-state-modal .order-state-label-text {
  box-sizing: border-box;
  display: block;
  width: 100%;
  min-width: 0;
  color: #425466;
  font-size: 14px;
  line-height: 1.5;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.yd-order-state-modal .order-state-option .order-state-label .order-state-label-text {
  padding-left: 32px;
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 24px 24px;
}

.yd-order-state-modal .order-state-item.is-past {
  background: #f6f8fa;
  border-color: #e6ebef;
}

.yd-order-state-modal .order-state-item.is-past .order-state-label-text {
  color: #9aa6af;
}

.yd-order-state-modal .order-state-item.is-current {
  background: #eef8fe;
  border-color: #b9def5;
  box-shadow: inset 3px 0 0 #7EC8F5;
}

.yd-order-state-modal .order-state-item.is-current .order-state-label-text.disabled {
  color: #326986;
  font-weight: 600;
  text-decoration: none;
}

.yd-order-state-modal .order-state-item.is-available .order-state-label {
  cursor: pointer;
}

.yd-order-state-modal .order-state-item.is-available:active {
  background: #f3f9fd;
  border-color: #9dd4f5;
}

.yd-order-state-modal .order-state-item.is-selected {
  background: #e7f5fe;
  border-color: #4DA9E8;
  box-shadow: 0 0 0 2px rgba(77, 169, 232, 0.14);
}

.yd-order-state-modal .order-state-item.is-selected .order-state-label-text {
  color: #1f5f86;
  font-weight: 700;
}

.yd-order-state-modal .order-state-footer {
  flex: 0 0 auto;
  border-top: 1px solid #edf1f4;
}

.yd-order-state-modal .order-state-actions {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding: 12px 16px;
  padding: 12px 16px max(12px, env(safe-area-inset-bottom));
}

.yd-order-state-modal .order-state-actions .order-state-button {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  min-height: 44px;
  height: auto;
  margin: 0;
  padding: 10px 12px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
  white-space: normal;
  overflow-wrap: anywhere;
}

.yd-order-state-modal .order-state-actions .order-state-cancel {
  color: #425466;
  background: #ffffff;
  border: 1px solid #cbd6de;
}

.yd-order-state-modal .order-state-actions .order-state-cancel:active {
  background: #f4f7f9;
  border-color: #aebdc7;
}

.yd-order-state-modal .order-state-actions .order-state-confirm {
  color: #ffffff;
  background: #7EC8F5;
  border: 1px solid #7EC8F5;
}

.yd-order-state-modal .order-state-actions .order-state-confirm:active {
  background: #4DA9E8;
  border-color: #4DA9E8;
}

.radio-txt.disabled {
  text-decoration: line-through;
}

@media (max-width: 360px) {
  .yd-order-state-modal .order-state-inner {
    padding-right: 8px;
    padding-left: 8px;
  }

  .yd-order-state-modal .order-state-actions {
    grid-template-columns: 1fr;
  }
}
</style>
/* *Created on 2023-10-27 *ProjectName user */
